import { useCallback } from "react";
import useWeb3 from "../useWeb3";
import { getTrade } from "../../utils/contractHelpers";
import { useRecoilValue } from "recoil";
import { userSmartAccount } from "../../components/RecoilAtom";

const usePublicPoolResolver = () => {
    const smartAccount = useRecoilValue(userSmartAccount)
    const web3 = useWeb3();
    
    const publicPoolResolver = useCallback(
        async (address) => {
            const contract = getTrade(address, web3);
            try {
                const resolver = await contract.methods.resolver().call();
                return resolver;
            } catch (error) {
                console.error("Error fetching balance:", error.message || error);
                throw error;
            }
        },
        [web3, smartAccount]
    );
    return publicPoolResolver ;
};

export default usePublicPoolResolver;